<template>
  <div>
    <div class="centered-header">
      <h2 class="ui header" style="color: #092442;">
        <i class="money bill outline icon"></i>
        <div class="content">
          New expense
        </div>
      </h2>
    </div>

    <div class="ui form clearing segment" id="transaction-form">

      <div class="field">
        <label for="transactionAmount">{{ $t('transactionAmount') }}</label>
        
        <div class="ui input left icon">
          <i class="money icon"></i>
          <input
            type="number"
            :placeholder="$t('transactionAmount')"
            v-model="transactionParams.amount"
            name="transactionAmount"
          />
        </div>
      </div>
      <!-- <div class="two required fields">
      </div> -->
      <div class="required field">
        <label for="paidAt">{{ $t('paidAt') }}</label>
        <div style="text-align: center" class="ui calendar" id="paid-at">
          <div class="ui input left icon">
            <i class="calendar icon"></i>
            <input
              type="text"
              :placeholder="$t('paidAt')"
              readonly=""
              name="paidAt"
            />
          </div>
        </div>
      </div>
      <div class="ui hidden divider"></div>
      <div class="required field">
        <div class="ui toggle checkbox">
          <input type="checkbox" v-model="transactionParams.online" />
          <label>Credit Card payment</label>
        </div>
      </div>
      <div class="ui hidden divider"></div>
      <div class="field">
        <label for="description">{{ $t('description') }}</label>
        <textarea
          :placeholder="$t('description')"
          v-model="transactionParams.description"
          name="description"
        >
        </textarea>
      </div>

      <div
        class="ui blue right floated button"
        style="background-color: #092442"
        @click="save()"
      >
        {{ $t('save') }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      transactionParams: {
        amount: null,
        description: null,
        paid_at: null,
        online: false
      },
    }
  },
  mounted () {
    this.initNewTransactionGui()
  }, 
  methods: {
    initNewTransactionGui() {
      this.$nextTick(() => {
        $('#paid-at').calendar({
          type: 'datetime',
          maxDate: new Date(),
          onChange: date => {
            this.transactionParams.paid_at = date;
          },
          isDisabled: (date, mode) => {
            return false;
          }
        });

        $('#transaction-form').form({
          inline: true,
          on: 'blur',
          fields: {
            transactionAmount: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please enter the transaction amount.'
                },
                {
                  type: 'number',
                  prompt: 'Please enter a valid number.'
                }
              ]
            },
            paidAt: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Choose reservation date.'
                }
              ]
            }
          }
        });
      });
    },
    save() {
      if ($('#transaction-form').form('is valid')) {
        this.transactionParams.is_purchase = true
        this.$http
          .post(`transactions`, { 
            transaction: this.transactionParams,
            clinic_id: this.getFromLocalStorage('clinicId') 
          })
          .then(() => {
            this.navigateTo('Transactions')
          });
      }
    }
  },
}
</script>

<style scoped>
  .centered-header {
    display: flex;
    justify-content: center;
    margin-top: 35px;
  }
</style>



// WEBPACK FOOTER //
// src/components/transactions/NewExpenseTransaction.vue